// extracted by mini-css-extract-plugin
export var DialogOverlay = "ModalTableLink-module--DialogOverlay--215g-";
export var fadeIn = "ModalTableLink-module--fadeIn--187Oj";
export var DialogContent = "ModalTableLink-module--DialogContent--2SJ4C";
export var CloseButton = "ModalTableLink-module--CloseButton--20d7A";